import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import CostcoApp from './CostcoApp';
import { isCostcoChaseHost } from './lib/productHost';
import reportWebVitals from './reportWebVitals';

const RootApp = isCostcoChaseHost() ? CostcoApp : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <RootApp />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
